import { FunctionComponent } from 'react';
import { FPEmailSentModal } from 'widgets/auth/forgotPassword/EmailSentModal';

export const ForgotPasswordEmailSent: FunctionComponent = () => {
	return <FPEmailSentModal />;
};
